/** head links a brand can replace; each file lives at `/<file>` by default and at `<assetDir><file>` for a brand */
export const BRAND_ICONS = [
  { selector: 'link[rel="apple-touch-icon"]', file: 'apple-touch-icon.png' },
  { selector: 'link[rel="icon"][sizes="32x32"]', file: 'favicon-32x32.png' },
  { selector: 'link[rel="icon"][sizes="16x16"]', file: 'favicon-16x16.png' },
  { selector: 'link[rel="manifest"]', file: 'site.webmanifest' },
];
